<template>
  <div class="page">
    <div class="cognitive">
      <div class="header">
        <div class="logoText">
          <img src="https://pro-yeahgo-oss.yeahgo.com/icon/report1.png" />
        </div>
        <div class="userInfo">
          <p>姓名：{{data.userName}}</p>
          <hr :style="{ marginTop: '-4px' }" />
          <p>年龄：{{data.age}}</p>
          <hr :style="{ marginTop: '-4px' }" />
          <p>性别：{{data.sex}}</p>
          <hr :style="{ marginTop: '-4px' }" />
        </div>
      </div>
      <div class="brainImage">
        <img src="https://pro-yeahgo-oss.yeahgo.com/icon/report2.png" />
      </div>
      <div class="footerInfo">
        <h1 class="title">
          <span :style="{ color: '#66c128' }">认知</span>
          训练报告
        </h1>
        <p class="timeInfo">
          训练难度：{{ data.star }}
          <br />
          训练周期{{ data.startDate }} ~ {{ data.endDate }}
        </p>
      </div>
    </div>
    <div class="divTitle">个人信息</div>
    <div class="divContent">
      <img :src="data.icon" v-if="data.icon" />
      <div class="contentRight">
        <div class="username">{{ data.userName }}</div>
        <div class="otherTxt"">年龄：{{ data.age }}岁</div>
        <div class=" otherTxt"">性别：{{ data.sex }}</div>
      </div>
    </div>
    <div class="tips">
      祝贺您，完成第
      <span>{{ data.numbers }}</span>
      期认知训练！本次完成率
      <span>{{ data.finishRate }}%</span>
      ，实际训练天数
      <span>{{ data.totalDays }}</span>
      天，累计训练时长
      <span>{{ data.times }}</span>
      ，希望您天天坚持训练，让大脑恢复年轻态！
    </div>
    <div class="divTitle">数据同比</div>
    <div class="chartsContent">
      <div class="charts1">
        <div class="info">
          <div class="imageText">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAA/0lEQVRIie3UOwoCMRSF4d9X4yYsXYbY2WhnZW2hK3Cwd9RaVLAQptZCsLJzDVYuwE2IoAQyEIYkJj4KJQemSEjyccPNEBIS8vPJ6QroHqvv1NUDGkAbuK5qZ+2i/IdvTqBzoAVsgIJp4TO46IF2gJkybgLJK3AZOAADRzTRnHcybTBVJNA9UJefyNgTjSx7jBXvFFAkNlRuQoc21AZvNXOxbJ40ooHWmjMmwMiGYrnqpXxq88x8Or7Iri1pUJeesHbtIoOp+E2z1xnF4TkJvK+Zz6JTH9QFTnHboUtf1BVGXmNkQMWN3L8FI5+Hir+M4vlLRHmblXfQkJCQPwjwAJbqK8EWxVfIAAAAAElFTkSuQmCC" />
            <div class="imageTextT">准确率</div>
            <div class="val">{{amountTransform(data.rightRate)}}%</div>
          </div>
          <div class="text">{{data.rightRateTip}}</div>
        </div>
        <div class="barCharts">
          <div class="content">
            <div>本期</div>
            <div class="bar">
              <div class="thisTime" :style="{width: `${amountTransform(data.rightRate)}%`}"></div>
            </div>
            <div>{{amountTransform(data.rightRate)}}%</div>
          </div>
          <div class="content">
            <div>上期</div>
            <div class="bar">
              <div class="lastTime" :style="{width: `${amountTransform(data.lastRightRate)}%`}"></div>
            </div>
            <div>{{amountTransform(data.lastRightRate)}}%</div>
          </div>
        </div>
      </div>
      <div class="charts2">
        <div class="info">
          <div class="imageText">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABaklEQVRIie3Wv0tXYRTH8Zc/EqFJhyIFN8tZBIMEoSX8AUaRg4LQIC6iUEs01BAEjg5N0twi4j8g2NAgODQmiTQGLtIgoihy4RG+iHnP8/XiIH7gwj33fu55cw6ccx+3uvFqKCtw+vuj84+e4xtaSz79sTS4NfC/l42ZnS38CwFoobdliXI0iocBf9GRjSrBbwKeA7wvM+WAezEY8C3iT5XgSLW7+BxJFgV3Yjzg+4h/VYJncafE8xtLwXwh8F3MBHzdOMQaWqoAv0ZbwCctpKfoqQI8H4SeaRO/qgA/yIBuYzi1/FI1B5JNYRJNKb6Pxxf4/uJZGqlSRcAr6TrTuwvAxQgNYScCVcfKlP5OtTrCGH7mJMkFd6G/Jj7BBNYz82SDX52L57CcC60HXNvmT/hSDzQX3IEn6f4rPtQLzQW/TJtpNbhCKwO/KM5RaaaPrwqOzHGhe2hPB4H9q0JlVNyHEexVAb3V9QmnGEQwGQZOQEoAAAAASUVORK5CYII=" />
            <div class="imageTextT">反应速率</div>
            <div class="val">{{data.speedRate}}秒</div>
          </div>
          <div class="text">{{data.lastSpeedtip}}</div>
        </div>
        <div class="lineCharts">
          <div id='speedCharts'></div>
        </div>
      </div>
    </div>
    <div class="divTitle">脑力成就</div>
    <div class="chartsContent">
      <div class="charts2">
        <div class="pic">
          <img :src="imgLevel" preview={false} width={150} />
        </div>
        <div class="status">
          <div :class="`statusBar ${data.totals < 800 ? 'active' : '' }`">
            <div class="bar1"></div>
            <div>学童</div>
          </div>
          <div :class="`statusBar ${(data.totals>= 800 && data.totals < 6000) ? 'active' : '' }`">
              <div class="bar2"></div>
              <div>智者</div>
          </div>
          <div :class="`statusBar ${data.totals>= 6000 ? 'active' : ''}`">
            <div class="bar3"></div>
            <div>脑尊</div>
          </div>
        </div>
      </div>
      <div class="charts2">
        <div class="barCharts">
          <div class="title">
            脑力提升
            <span>{{data.totals}}</span>
          </div>
          <div id='upBrainCharts' class="brainCharts"></div>
        </div>
      </div>
    </div>
    <div class="divTitle">准确率分布</div>
    <div class="charts" id='rightRate'></div>
    <div class="divTitle">反应速率分布</div>
    <div class="charts" id='speedRate'></div>
    <div class="divTitle">饮食建议</div>
    <div v-html="data.dietaryAdvice" />
  </div>
</template>

<script>
import Vue from "vue";
import * as echarts from 'echarts'
import { post } from "@/utils/request";
import util from "@/utils/util"

export default {
  components: {
  },
  mounted() {
    post({
      url: '/healthy/open/game/planReport',
      data: {
        id: this.$route.query.id,
      },
      options: {
        token: this.$route.query.token
      }
    }).then(res => {
      if (res.code == 0) {
        if(res.data.totals < 800) {
            this.imgLevel = 'https://pro-yeahgo-oss.yeahgo.com/icon/level1.png'
          } else if(res.data.totals >= 800 && res.data.totals < 6000) {
            this.imgLevel = 'https://pro-yeahgo-oss.yeahgo.com/icon/level2.png'
          } else {
            this.imgLevel = 'https://pro-yeahgo-oss.yeahgo.com/icon/level3.png'
          }
        this.data = res.data

        this.init(res.data)
        this.init2(res.data)
        this.init3(res.data)
        this.init4(res.data)
      }
    })
  },
  methods: {
    amountTransform(v) {
      return util.multiply(v, 100)
    },
    init(data) {
      const chartDom = document.getElementById('speedRate')
      const myChart = echarts.init(chartDom)
      const xAxisData = data?.speedRateRecords.map(res => res.pDate)
      const jyData = data?.speedRateRecords.map(res => res.jiyi)
      const sjData = data?.speedRateRecords.map(res => res.shijue)
      const jsData = data?.speedRateRecords.map(res => res.jisuan)
      const fyData = data?.speedRateRecords.map(res => res.fanying)

      const option = {
        color: ['#28d065', '#fad157', '#a079f0', '#0359ea'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['记忆', '视觉', '计算', '反应'],
          top: 10,
          right: 0
        },
        grid: {
          top: 40,
          left: 0,
          right: 0,
          bottom: 0,
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            formatter: '{value}s'
          },
          axisLine: {
            show: true,
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '记忆',
            type: 'line',
            data: jyData,
            smooth: true,
          },
          {
            name: '视觉',
            type: 'line',
            data: sjData,
            smooth: true,
          },
          {
            name: '计算',
            type: 'line',
            data: jsData,
            smooth: true,
          },
          {
            name: '反应',
            type: 'line',
            data: fyData,
            smooth: true,
          },
        ]
      }
      option && option && myChart.setOption(option)
    },
    init2(data) {
      const chartDom = document.getElementById('rightRate')
      const myChart = echarts.init(chartDom)
      const xAxisData = data?.rightRateRecords.map(res => res.pDate)
      const jyData = data?.rightRateRecords.map(res => res.jiyi)
      const sjData = data?.rightRateRecords.map(res => res.shijue)
      const jsData = data?.rightRateRecords.map(res => res.jisuan)
      const fyData = data?.rightRateRecords.map(res => res.fanying)

      const option = {
        color: ['#28d065', '#fad157', '#a079f0', '#0359ea'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['记忆', '视觉', '计算', '反应'],
          top: 10,
          right: 0
        },
        grid: {
          top: 40,
          left: 0,
          right: 0,
          bottom: 0,
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            formatter: '{value}%'
          },
          axisLine: {
            show: true
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '记忆',
            type: 'line',
            data: jyData,
            smooth: true,
          },
          {
            name: '视觉',
            type: 'line',
            data: sjData,
            smooth: true,
          },
          {
            name: '计算',
            type: 'line',
            data: jsData,
            smooth: true,
          },
          {
            name: '反应',
            type: 'line',
            data: fyData,
            smooth: true,
          },
        ]
      }
      option && option && myChart.setOption(option)
    },
    init3(data) {
      const chartDom = document.getElementById('upBrainCharts')
      const myChart = echarts.init(chartDom)
      const option = {
        color: '#66c128',
        grid: {
          top: 30,
          bottom: 0,
          left: 0,
          right: 0
        },
        xAxis: {
          type: 'category',
          data: ['视觉', '记忆', '计算', '反应']
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: [data?.shijue, data?.jiyi, data?.jisuan, data?.fanying],
            type: 'bar',
            barWidth: 30,
            label: {
              show: true,
              position: 'top',
              formatter: '+{c}',
              color: '#66c128',
            },
          }
        ]
      }
      option && option && myChart.setOption(option)
    },
    init4(data) {
      const chartDom = document.getElementById('speedCharts')
      const myChart = echarts.init(chartDom)
      const option = {
        xAxis: {
          type: 'category',
          data: ['本期', '上期']
        },
        yAxis: {
          show: false
        },
        grid: {
          //top: 0,
          bottom: 0
        },
        series: [
          {
            data: [
              {
                value: data?.speedRate,
                itemStyle: {
                  color: '#4fb0ff'
                }
              },
              {
                value: data?.lastSpeedRate,
                itemStyle: {
                  color: '#cfcfcf'
                }
              }
            ],
            type: 'bar',
            barWidth: 30,
            label: {
              show: true,
              position: 'top',
              formatter: '{c}秒'
            },
          },
        ]
      }
      option && myChart.setOption(option)
    }
  },
  data() {
    return {
      data: {},
      styles: {},
      info: {},
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 20px 10px;
  overflow: hidden;
  background:#fff;
}

.cognitive {
  padding: 20px;
  font-family: Arial, sans-serif;
  margin-bottom: 140px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;

    .logoText {
      font-size: 24px;
      font-weight: 700;
      margin: 0;
      img {
        width: 150px;
      }
    }

    .userInfo {
      p {
        margin: 5px 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000;
      }
    }
  }

  .brainImage {
    text-align: center;
    margin: 40px 0;

    img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }

  .footerInfo {
    text-align: center;
    margin-top: 60px;

    .title {
      font-size: 36px;
      margin-bottom: 20px;
      font-weight: 700;
      color: #000;
    }

    .timeInfo {
      font-size: 16px;
      color: #666;
      font-weight: 400;
    }
  }
}

.divTitle {
  background: url(data:image/png;base64,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);
  background-position: 0;
  background-repeat: no-repeat;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #356fc3;
  font-weight: 700;
}

.divContent {
  display: flex;
  margin-top: 25px;
  margin-bottom: 40px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .contentRight {
    color: #000;

    .username {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 8px;
      color: #000;
    }

    .otherTxt {
      font-size: 14px;
      opacity: .6;
    }
  }
}

.tips {
  font-size: 14px;
  margin-bottom: 20px;

  span {
    color: #66c128;
  }
}

.chartsContent {
  // display: flex;
  margin: 10px 20px;

  .charts1 {
    // width: 50%;
    // border-right: 1px solid #cecece;
  }

  .charts2 {
    // width: 50%;

    .lineCharts {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;

      div {
        width: 180px;
        height: 120px;
      }
    }

    .pic {
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        width: 150px;
      }
    }

    .status {
      display: flex;
      justify-content: center;

      .statusBar {
        text-align: center;
        line-height: 34px;

        .bar1 {
          width: 50px;
          height: 10px;
          background-color: #dadcd9;
          border-radius: 6px 0 0 6px;
        }

        .bar2 {
          width: 50px;
          height: 10px;
          background-color: #dadcd9;
          margin: 0 2px;
        }

        .bar3 {
          width: 50px;
          height: 10px;
          background-color: #dadcd9;
          border-radius: 0 6px 6px 0;
        }
      }

      .active {
        font-size: 18px !important;
        font-weight: 700;
        position: relative;

        ::before {
          content: '';
          display: block;
          position: absolute;
          top: -10px;
          left: 22px;
          border-left: 6px solid transparent;
          border-top: 6px solid #66c128;
          border-right: 6px solid transparent;
          border-bottom: 6px solid transparent;
        }

        .bar1,
        .bar2,
        .bar3 {
          background-color: #66c128 !important;
        }
      }
    }

    .barCharts {
      margin-top: 20px;
      align-items: center;

      .title {
        background-color: #66c128;
        font-size: 16px;
        text-align: center;
        padding: 6px 0;
        // line-height: 18px;
        border-radius: 18px;
        overflow: hidden;
        // width: 140px;
        font-weight: 700;
        padding: 10px 20px;
        
        

        span {
          font-size: 24px;
          position: relative;
          top: 2px;
        }
      }

      .brainCharts {
        width: 300px;
        height: 170px;
      }
    }
  }

  .info {
    text-align: center;

    .imageText {
      display: flex;
      align-items: center;
      justify-content: center;

      .imageTextT {
        font-size: 18px;
        color: #859eb8;
        margin: 0 5px;
      }

      .val {
        font-size: 24px;
        font-weight: 700;
        line-height: 12px;
      }
    }

    .text {
      font-size: 12px;
    }
  }

  .barCharts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 20px;
    margin-top: 30px;

    .content {
      display: flex;
      align-items: center;
      padding-bottom: 20px;

      .bar {
        width: 230px;
        height: 25px;
        background-color: #e8e8e8;
        margin: 0 10px;

        .thisTime {
          background-color: #4fb0ff;
          height: 100%;
        }

        .lastTime {
          background-color: #a7aca6;
          height: 100%;
        }
      }
    }
  }
}

.charts {
  width: 100%;
  height: 200px;
  margin: 10px 0 20px;
}
</style>
